export default 'white75';